export default {
    type: 'podcast',
    name: 'Podcast',
    osOnly: false,
    components: {
        root: {
            name: 'ModulePodcast',
            loader: () => import('./ModulePodcast')
        },
        form: {
            name: 'ModulePodcastForm',
            loader: () => import('./ModulePodcastForm')
        }
    }
};
